import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class NullLiteralCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.NullKeyword;
    }
    visitNode(sb, expr, options) {
        if (options.pushValue) {
            sb.emitHelper(expr, options, sb.helpers.wrapNull);
        }
    }
}

//# sourceMappingURL=NullLiteralCompiler.js.map
